import { isString } from "./type_checking";
var fragment;
function initFragment() {
    if (fragment)
        return;
    fragment = document.implementation.createHTMLDocument('');
    var base = fragment.createElement('base');
    base.href = document.location.href;
    fragment.head.appendChild(base);
}
function parseHTML(html) {
    initFragment();
    if (!isString(html))
        html = '';
    fragment.body.innerHTML = html.trim();
    return fragment.body.childNodes[0];
}
export default parseHTML;
